import { useEffect, useState } from "react";
import "./LeadFunnel.scss";
import StagePopup from "./StagePopup";
import {
  getLeadJourneyDropOutAnalysis,
  getLeadJourneyStageAnalysis,
} from "../ActionCreator";
import moment from "moment";
import { Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";


const stageLabelMap = {
  LEAD_CREATED: "Leads Received",
  CREDIT_APPROVED: "Credit Approval",
  OPS_VERIFIED: "Ops Verified",
  AGREEMENT_SIGNED: "Agreement Signed",
  DISBURSED: "Leads Converted",
};

const formatStages = (data) =>
  data.map((item, index) => ({
    id: index + 1,
    count: item.applications,
    label: stageLabelMap[item.stage] || item.stage,
    expenses: `₹${Number(item.expenses).toLocaleString("en-IN")}`,
    color: `c${index + 1}`,
  }));

const formatTransitions = (data) =>
  data.slice(1).map((item) => ({
    dropOff: `${item.dropOffPercent}%`,
    cost: `₹${Number(item.expenses).toLocaleString("en-IN")}`,
    expenses: `₹${Number(item.expenses).toLocaleString("en-IN")}`,
    bgColor: "#f8f2ff",
  }));

const DropIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="23 18 13.5 8.5 8.5 13.5 1 6" />
    <polyline points="17 18 23 18 23 12" />
  </svg>
);

const TrendUpIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
    <polyline points="17 6 23 6 23 12" />
  </svg>
);

const StartDetail = ({ data }) => (
  <div className="detail" style={{ backgroundColor: "#f0fdfa" }}>
    <div></div>
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        backgroundColor: "#d0eddd",
        padding: "5px 10px",
        borderRadius: "10px",
        marginBottom: "10px",
      }}
    >
      <label className="" style={{ display: "flex", gap: "10px" }}>
        <span className="dot" style={{ color: "green" }} />

        <span> Starting Stage</span>
      </label>
    </div>
    <div
      className=""
      style={{ display: "flex", justifyContent: "space-between" }}
    >
      <label style={{ color: "#bb720d", fontWeight: 500 }}>Expenses</label>
      <span className="" style={{ color: "#bb720d", fontWeight: 700 }}>
        {data?.expenses}
      </span>
    </div>
  </div>
);

const FinalDetail = ({ data }) => (
  <div className="detail" style={{ backgroundColor: "#f0fdfa" }}>
    <div></div>
    <div
      className=""
      style={{
        display: "flex",
        justifyContent: "center",
        backgroundColor: "#d0eddd",
        padding: "5px 10px",
        borderRadius: "10px",
        marginBottom: "10px",
      }}
    >
      <label className="" style={{ display: "flex", gap: "10px" }}>
        <span style={{ color: "green" }}>
          {" "}
          <TrendUpIcon />{" "}
        </span>
        <span> Final Output</span>
      </label>
    </div>

    <div
      className=""
      style={{ display: "flex", justifyContent: "space-between" }}
    >
      <label style={{ color: "#bb720d", fontWeight: 500 }}>Expenses</label>
      <span className="" style={{ color: "#bb720d", fontWeight: 700 }}>
        {data?.expenses}
      </span>
    </div>
  </div>
);

// const TransitionDetail = ({ data }) => (
//     <div className="detail" style={{ backgroundColor: data?.bgColor }}>
//     <div
//       className=""
//       style={{
//         display: "flex",
//         justifyContent: "space-between",
//         margin: "10px 0px",
//       }}
//     >
//       <label className="d-flex gap-3" style={{ display: "flex", gap: "10px" }}>
//         <span style={{ color: "red" }}>
//           <DropIcon />{" "}
//         </span>
//         <span style={{ color: "#e85859", fontWeight: 500 }}>Drop Off %</span>
//       </label>
//       <span className="" style={{ color: "#e85859", fontWeight: 700 }}>
//         {data.dropOff}
//       </span>
//     </div>
//     <div
//       className=""
//       style={{ display: "flex", justifyContent: "space-between" }}
//     >
//       <label style={{ color: "#bb720d", fontWeight: 500 }}>Expenses</label>
//       <span className="" style={{ color: "#bb720d", fontWeight: 700 }}>
//         {data?.expenses}
//       </span>
//     </div>
//   </div>
// );



const TransitionDetail = ({ data, stage }) => (
  <div className="detail" style={{ backgroundColor: data?.bgColor }}>

    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        margin: "10px 0px",
      }}
    >
      <label style={{ display: "flex", gap: "10px" }}>
        <span style={{ color: "red" }}>
          <DropIcon />
        </span>
        <span style={{ color: "#e85859", fontWeight: 500 }}>
          Drop Off %
        </span>
      </label>

      <span style={{ color: "#e85859", fontWeight: 700 }}>
        {data.dropOff}
      </span>
    </div>

    <div style={{ display: "flex", justifyContent: "space-between" }}>

      <label
        style={{
          color: "#bb720d",
          fontWeight: 500,
          display: "flex",
          alignItems: "center",
          gap: "6px",
        }}
      >
        Expenses

        {/* ✅ Correct condition */}
        {stage === "Ops Verified" && (
          <Tooltip title="Leads Received + Credit Approval" arrow componentsProps={{
            tooltip: {
              sx: {
                fontSize: "11px",
                fontWeight: 500,
                padding: "8px 12px",
                borderRadius: "6px",
              },
            },
          }}>
            <InfoOutlinedIcon
              style={{ fontSize: "13px", cursor: "pointer" }}
            />
          </Tooltip>
        )}
      </label>

      <span style={{ color: "#bb720d", fontWeight: 700 }}>
        {data?.expenses}
      </span>
    </div>
  </div>
);

export default function LeadJourneyFunnel({ data = [], customDate }) {
  const defaultStages = [
    { stage: "LEAD_CREATED", applications: 0, expenses: 0 },
    { stage: "CREDIT_APPROVED", applications: 0, expenses: 0 },
    { stage: "OPS_VERIFIED", applications: 0, expenses: 0 },
    // { stage: "AGREEMENT_SIGNED", applications: 0, expenses: 0 },
    { stage: "DISBURSED", applications: 0, expenses: 0 },
  ];
  const safeData = data && data.length > 0 ? data : defaultStages;
  const STAGES = formatStages(safeData);
  const TRANSITIONS = formatTransitions(safeData);
  const isEmpty = !data || data.length === 0;

  const [active, setActive] = useState(null);
  const [popupOpen, setPopupOpen] = useState(false);
  const [selectedStage, setSelectedStage] = useState(null);
  const [dropOutAnalysis, setDropOutAnalysis] = useState(null);
  const [stageAnalysis, setStageAnalysis] = useState(null);
  const [currentStage, setCurrentStage] = useState();
  const [nextStage, setNextStage] = useState();
  const [loader, setLoader] = useState(false);

  const handleStageClick = (stage, idx) => {
    const sDate = moment(customDate?.from)?.format("DD-MM-YYYY");
    const eDate = moment(customDate?.to)?.format("DD-MM-YYYY");

    if (idx === data.length - 1) return;

    const currentStage = data[idx]?.stage;
    const nextStage = data[idx + 1]?.stage;

    setCurrentStage(currentStage);
    setNextStage(nextStage);

    setActive(stage.id);
    setSelectedStage(stage);
    setPopupOpen(true);
    setLoader(true);
    getLeadJourneyDropOutAnalysis(
      sDate,
      eDate,
      currentStage,
      nextStage,
      (res) => {
        setDropOutAnalysis(res);
        setStageAnalysis(res);
        setLoader(false);
      },
    );

    // setLoader(true);
    // getLeadJourneyStageAnalysis(
    //   sDate,
    //   eDate,
    //   currentStage,
    //   nextStage,
    //   (res) => {
    //     setStageAnalysis(res);
    //     setLoader(false);
    //   },
    // );
  };

  return (
    <div className="ljf">
      <div className="ljf-header">
        <h5>Lead Journey Funnel (Apply Date)</h5>
        <span>Click on any stage for detailed analysis</span>
      </div>

      <div className="ljf-funnel" style={{ gap: "15px" }}>
        {STAGES?.map((stage, idx) => (
          <div className="ljf-stage" key={stage.id}>
            {/* <div
              className={`card ${stage.color} ${idx === 0 ? "disabled" : ""} ${
                active === stage.id ? "active" : ""
              } ${isEmpty ? "disabled" : ""} mb-3`}
                title={isEmpty ? "" : "Click to view detailed analysis"}
              onClick={() => {
                if (isEmpty) return;
                handleStageClick(stage, idx);
              }}
            >
              <h3>{stage.count}</h3>
              <p>{stage.label === 'Leads Converted' ? `${stage.label} (For Lead Disbursed)` :stage.label}</p>
            </div> */}
            <Tooltip
              title="Click to view detailed analysis"
              arrow
              placement="top"
              enterDelay={0}
              leaveDelay={0}
              componentsProps={{
                tooltip: {
                  sx: {
                    display: idx ==0 || idx == 3 ?"none" :"",
                    fontSize: "13px",
                    fontWeight: 500,
                    padding: "8px 12px",
                    borderRadius: "6px",
                  },
                },
              }}
            >
              <div
                className={`card ${stage.color} ${idx === 0 ? "disabled" : ""} ${active === stage.id ? "active" : ""
                  } ${isEmpty ? "disabled" : ""} mb-3`}
                style={{ cursor: isEmpty ? "not-allowed" : "pointer" }}
                onClick={() => {
                  if (isEmpty) return;
                  if(idx == 0) return;
                  handleStageClick(stage, idx);
                }}
              >
                <h3>{stage.count}</h3>
                <p>
                  {stage.label === "Leads Converted"
                    ? `${stage.label} (For Lead Disbursed)`
                    : stage.label}
                </p>
              </div>
            </Tooltip>

            {idx === 0 && <StartDetail data={stage} />}

            {idx > 0 && idx < STAGES.length - 1 && (
              <TransitionDetail data={TRANSITIONS[idx - 1]} stage={STAGES[idx]?.label} />
            )}

            {idx === STAGES.length - 1 && <FinalDetail data={stage} />}
          </div>
        ))}
      </div>

      <StagePopup
        open={popupOpen}
        stage={selectedStage}
        date={customDate}
        dropOutAnalysis={dropOutAnalysis}
        stageAnalysis={stageAnalysis}
        onClose={() => setPopupOpen(false)}
        currentStage={currentStage}
        nextStage={nextStage}
        loader={loader}
      />
    </div>
  );
}
